<!-- TODO: This needs to be abstracted more. This was created by Ritu as a wrapper for the video Card on PD, but the issue is that to much PD login is tied to it. -->
<template>
   <ClientOnly>
      <div v-if="card?.video || card?.value" class="video-wrapper">
         <div
            :class="[
               'no-print',
               `wistia_embed wistia_async_${
                  card?.video?.hashed_id ?? card?.value
               }`,
            ]"
         />
      </div>
   </ClientOnly>
</template>

<script setup lang="ts">
const { $posthog } = useNuxtApp();
const emits = defineEmits(["playing"]);
const props = defineProps({
   card: { type: Object, default: () => {} },
});
const playing = ref(false);
const wistiaSetup = () => {
   window._wq = window._wq || [];
   _wq.push({
      id: props.card?.video?.hashed_id ?? props.card?.value,
      options: {
         copyLinkAndThumbnailEnabled: false,
         settingsControl: false,
         controlsVisibleOnLoad: false,
         playerColor: "#0071bb",
         videoFoam: true,
      },
      // onEmbedded: (video) => {
      //    console.log("onEmbedded", video);
      // },
      onReady: function (video) {
         video.bind("play", function () {
            playing.value = true;
            $posthog().capture("video_played", {
               video_title: video?._originalMediaData?.name,
            });
         });
         video.bind("pause", function () {
            playing.value = false;
         });
         video.bind("end", function () {
            playing.value = false;
            $posthog().capture("video_completed", {
               video_title: video?._originalMediaData?.name,
            });
         });
         // video.bind("heightchange", function () {});
      },
   });
};
const init = () => {
   if (props.card?.video?.hashed_id ?? props.card?.value) {
      wistiaSetup();
   }
};
watchEffect(() => {
   emits("playing", playing.value);
});
onUpdated(() => {
   init();
});
onMounted(() => {
   init();
});
</script>

<style lang="scss">
.wistia_embed {
   // @include width(10, 9);
   width: 100%;
   height: fit-content;
   > * {
      // height:  fit-content !important;
   }
}

div.video-wrapper {
   .close-modal-button {
      position: absolute;
      top: pad(3);
      right: pad(3);
      cursor: pointer;
   }

   .caption {
      position: absolute;
      bottom: pad(2);
      left: pad(3);
   }

   .see-more {
      position: absolute;
      bottom: pad(2);
      right: pad(2);
   }
}
</style>
